// @flow
import { push } from 'react-router-redux';
import { fetchMe } from './user.actions';

import { getAccounts, getWebProperties } from './project.actions';
const GET_PLANS = '/api/plans?coupon=:coupon';
const SET_ACCOUNT = '/api/projects/:id/select-account?tid=:tid';
const SAVE_PLAN = '/api/projects/:id/plan';
const WIZARD_API = '/api/projects/:id/wizard';

/*STRIPE CHECKOUT*/
const GET_STRIPE_SESSION = '/api/projects/:id/changePlan';

export const PLANS_UPDATED = 'plans/UPDATED';
export const PLANS_UPDATING = 'plans/UPDATING';
export const WIZARD_PASSED = 'wizard/PASSED';
export const WIZARD_SAVING = 'wizard/SAVING';
export const WIZARD_SAVED = 'wizard/SAVED';
export const WIZARD_START_SELECT_ACCOUNT = 'wizard/WIZARD_START_SELECT_ACCOUNT';
export const WIZARD_END_SELECT_ACCOUNT = 'wizard/WIZARD_END_SELECT_ACCOUNT';

const { dataLayer } = window;

export const getPassedSteps = ({ steps }: { steps: Array<string> }) => {
  return (dispatch: Function) => {
    dispatch({ type: WIZARD_PASSED, data: steps });
  };
};

/*STRIPE CHECKOUT*/
export const stripeCheckout = ({
  user,
  id = 0,
  plan,
  coupon,
  stripe_key,
  currency,
  cb
}: {
  user: Object,
  plan: Object,
  id: number,
  stripe_key: string,
  coupon: string,
  currency: string,
  cb: Function
}) => {
  return (dispatch: Function) => {
    dispatch({ type: WIZARD_SAVING });
    let planPayload = {
      planId: plan.id,
      coupon
    };
    if (coupon && coupon.length > 0) dataLayer.push({ coupon: coupon });
    dataLayer.push({ revenue: plan.price });
    dataLayer.push({ plan: plan.id });
    dataLayer.push({ currency });

    if (!user.stripeCustomerId && plan.price) {
      planPayload = { ...planPayload };
    }
    return fetch(GET_STRIPE_SESSION.replace(':id', `${id}`), {
      method: 'PUT',
      body: JSON.stringify(planPayload),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        dispatch({ type: WIZARD_SAVED, action: { id } });
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (!!data.session) {
          var stripe = window.Stripe(stripe_key);
          return stripe
            .redirectToCheckout({
              // Make the id field from the Checkout Session creation API response
              // available to this file, so you can provide it as parameter here
              // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
              sessionId: data.session.id
            })
            .then(function(result) {
              // If `redirectToCheckout` fails due to a browser or network
              // error, display the localized error message to your customer
              // using `result.error.message`.
            });
        }
        if (status === 200) {
          dispatch(
            fetchMe(() => {
              cb && cb.call(this, data);
            })
          );
        }
      });

    //get session
    //if session - make redirect
    //if error - show message
    //if pass - go to next page
    /*return fetch(SAVE_PLAN.replace(':id', `${id}`), {
      method: 'PUT',
      body: JSON.stringify(planPayload),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        dispatch({ type: WIZARD_SAVED, action: { id } });
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(
            fetchMe(() => {
              cb && cb.call(this, data);
            })
          );
        }
      });*/
  };
};

export const getPlansByCoupon = ({ coupon }: { coupon: string }) => {
  return (dispatch: Function) => {
    dispatch({ type: PLANS_UPDATING });
    fetch(GET_PLANS.replace(':coupon', coupon), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        dispatch({ type: PLANS_UPDATED, data });
      });
  };
};

export const selectAccount = ({
  tid,
  projectId,
  accountId
}: {
  tid: string,
  projectId: string,
  accountId: string
}) => (dispatch: Function) => {
  dispatch({ type: WIZARD_START_SELECT_ACCOUNT });

  fetch(SET_ACCOUNT.replace(':tid', tid).replace(':id', projectId), {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Cache: 'no-cache'
    },
    credentials: 'include'
  }).then(() => {
    const cb = (data) => {
      if (data && data[0] && data[0].id && !accountId) {
        dispatch(getWebProperties({ id: projectId, accountId: data[0].id }));
      }
    };

    dispatch({ type: WIZARD_END_SELECT_ACCOUNT });
    dispatch(fetchMe(() => dispatch(getAccounts({ id: projectId, cb }))));
  });
};

export const selectPlan = ({
  token,
  user,
  id = 0,
  plan,
  coupon,
  currency,
  cb
}: {
  token: Object,
  user: Object,
  plan: Object,
  id: number,
  coupon: string,
  currency: string,
  cb: Function
}) => {
  return (dispatch: Function) => {
    dispatch({ type: WIZARD_SAVING });
    let planPayload = {
      planId: plan.id,
      coupon
    };
    if (coupon && coupon.length > 0) dataLayer.push({ coupon: coupon });
    dataLayer.push({ revenue: plan.price });
    dataLayer.push({ plan: plan.id });
    dataLayer.push({ currency });

    if (!user.stripeCustomerId && token && token.id && plan.price) {
      planPayload = { ...planPayload, token: token.id };
    }

    return fetch(SAVE_PLAN.replace(':id', `${id}`), {
      method: 'PUT',
      body: JSON.stringify(planPayload),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        dispatch({ type: WIZARD_SAVED, action: { id } });
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(
            fetchMe(() => {
              cb && cb.call(this, data);
            })
          );
        }
      });
  };
};
export const wizardDone = ({ id = 0, cb }: { id: number, cb: Function }) => {
  return (dispatch: Function) => {
    dispatch({ type: WIZARD_SAVING });

    return fetch(WIZARD_API.replace(':id', `${id}`), {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        dispatch({ type: WIZARD_SAVED, action: { id } });
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 200) {
          dataLayer.push({ event: 'setup_completed' });
          dispatch(fetchMe());
          cb && cb.call(this, data);
        }
      });
  };
};

export const setClientDone = ({ id, cb }: { id: string, cb: Function }) => {
  return (dispatch: Function) => {
    dispatch({ type: WIZARD_SAVING });

    return fetch(`${WIZARD_API.replace(':id', `${id}`)}/client-done`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        dispatch({ type: WIZARD_SAVED });
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(fetchMe());
          cb && cb.call(this, data);
        }
      });
  };
};

export default {
  getPlansByCoupon,
  getPassedSteps,
  selectPlan,
  stripeCheckout,
  setClientDone,
  wizardDone,
  selectAccount
};



// WEBPACK FOOTER //
// ./src/actions/wizard.actions.js